/**
 * @file     useAddressSearchParams.ts
 * @purpose  Read the address-bar query without Next useSearchParams. A map
 *           quick view pushes `?listing=` via history; useSearchParams can
 *           suspend /properties back to PropertiesShellFallback and lock the
 *           page on the loading skeleton.
 */
'use client';

import { useEffect, useMemo, useState } from 'react';

export function useAddressSearchParams(): URLSearchParams {
  // Empty on the first paint so SSR and hydration match. Deep-link pins
  // (`landing_pin`, `pin_*`) apply after mount.
  const [search, setSearch] = useState('');
  useEffect(() => {
    const sync = () => setSearch(window.location.search);
    sync();
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);
  return useMemo(() => new URLSearchParams(search), [search]);
}
